import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { Subscription } from "rxjs";
import { AlertasComponent } from '../../../alertas/alertas.component';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import {PaymentSupportService} from "../../../flash-payment/flash-payment-core/services/payment-support.service";
@Component({
  selector: 'app-confirmation-recharge',
  templateUrl: './confirmation-recharge.component.html',
  styleUrls: ['./confirmation-recharge.component.sass']
})
export class ConfirmationRechargeComponent implements OnInit {

  public subscriber;
  public selectBan;
  public prepaidBalance;
  public token: string = sessionStorage.getItem("token");
  @Input() amount;
  @Input() tax;
  @Input() totalPagar;
  @Output() updateScreenView = new EventEmitter();
  @Output() updateIdTransaction = new EventEmitter();
  @Output() updateIdTransactionRecarga = new EventEmitter();
  @Output() updateInitializeData = new EventEmitter();
  rechargeReceived: Subscription;
  constructor(private global: GlobalService,public dialog: MatDialog,  private paymentSupport: PaymentSupportService ) { }

  ngOnInit() {
    this.rechargeReceived = this.global.rechargeReceived.subscribe((value: string) => {
      this.updateIdTransaction.emit(value[0]);
      this.updateIdTransactionRecarga.emit(value[1]);
      this.updateScreenView.emit(4);
    });
    this.prepaidBalance = atob(sessionStorage.getItem("prepaidBalance"));
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.subscriber = this.global.getSuscriberByDefault(this.selectBan);

  }
  twoDec(num) {
    num = Math.round(num * 100) / 100;
    return num;
  }
  continuePrepaidRecharge() {
    let typeMessage='prepaid';
    if (this.global.validateSession() === true) {
      //  const paymentSupportPayload = JSON.parse(sessionStorage.getItem('paymentSupportPayload'));
      if (sessionStorage.getItem('canUseNewMethod')) {
        this.paymentSupport.paymentRefactorProcess(typeMessage, this.totalPagar.toString(), this.selectBan, this.token);
      } else {
         this.global.newPaymentNoLimit(2,typeMessage,this.selectBan, atob(sessionStorage.getItem("defaultSubscriber")), this.twoDec(this.totalPagar), atob(sessionStorage.getItem("email")), sessionStorage.getItem("name"),"", this.token);
      }
    }
  }
  cancelPrepaidRecharge() {
    if (this.global.validateSession() === true) {
      this.updateScreenView.emit(1);
    }
  }

}

